import { AssessmentState } from '../models/assessment';
import { getAssessmentById, invalidateAssessmentCache } from '../api/getAssessmentById';
import { isQuestionAnswered } from './isQuestionAnswered';

const delay = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));

function hasAllAnswers(assessment: AssessmentState): boolean {
  return assessment.questions.every(isQuestionAnswered);
}

export function pollForCompletedAssessment(
  assessmentId: string,
  responseId: string,
  maxAttempts = 5,
  delayMs = 1000
): Promise<AssessmentState> {
  function attempt(remaining: number): Promise<AssessmentState> {
    invalidateAssessmentCache(assessmentId);

    return getAssessmentById(assessmentId, responseId).then(assessmentData => {
      if (hasAllAnswers(assessmentData)) {
        return assessmentData;
      }

      if (remaining <= 1) {
        throw new Error(
          `Assessment answers were not fully populated after ${maxAttempts} attempts for assessment ${assessmentId}`
        );
      }

      return delay(delayMs).then(() => attempt(remaining - 1));
    });
  }

  return attempt(maxAttempts);
}
